/**
 * CSS border-box height (px) of the jump pill: the Figma pill is 28px tall
 * with a 3px CENTER-aligned gradient stroke, so the CSS box extends 1.5px
 * past the Figma outline on each side.
 */
export const JUMP_PILL_HEIGHT_PX = 31

/**
 * How far (px) the pill's center floats above its target checkpoint's
 * center, measured from Figma "speed up btn" (node 23082:49264, file
 * Lqc5IT4YdGMUgh0JWgO8zK, Focus Pass Events): the pill's Figma box sits at
 * y 2..30 in the 57×51 group and the checkpoint center falls at y 61.5.
 */
export const JUMP_PILL_CENTER_ABOVE_CHECKPOINT_PX = 45.5

/**
 * Top of the checkpoint-sized box `score` falls in, on a track whose nodes
 * sit `step` px apart: find the containing segment and interpolate, clamped
 * to the track's ends. A jump point's required_score always equals a
 * checkpoint score (GLOSSARY.md, decided 2026-07-23), so in practice this
 * lands exactly on a node; interpolation is graceful degradation only.
 */
function getScoreTop(
  score: number,
  checkpoints: number[],
  step: number,
): number {
  const totalHeight = (checkpoints.length - 1) * step
  const idx = checkpoints.findIndex((cp) => cp > score)
  if (idx === -1) return totalHeight
  if (idx === 0) return 0
  const prev = checkpoints[idx - 1]
  const next = checkpoints[idx]
  const segmentRatio = (score - prev) / (next - prev)
  return (idx - 1 + segmentRatio) * step
}

/**
 * Top offset (px) of a jump point's pill+chevron button group, positioned
 * so the pill's center floats JUMP_PILL_CENTER_ABOVE_CHECKPOINT_PX above
 * the target checkpoint's center. The group's box starts at the pill's CSS
 * border-box top.
 */
export function getJumpPillGroupTop(
  requiredScore: number,
  checkpoints: number[],
  step: number,
  checkpointSize: number,
): number {
  return (
    getScoreTop(requiredScore, checkpoints, step) +
    checkpointSize / 2 -
    JUMP_PILL_CENTER_ABOVE_CHECKPOINT_PX -
    JUMP_PILL_HEIGHT_PX / 2
  )
}
